import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getSameDayCancellationDetail,
  getSameDayCancellationOverview,
  type SameDayCancellationDetailResult,
  type SameDayCancellationOverviewResult,
} from '@services/api/dashboard/scheduling.api'

export function useSameDayCancellation(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<SameDayCancellationDetailResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getSameDayCancellationDetail, {
    enabled,
    queued,
  })
}

export function useSameDayCancellationOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<SameDayCancellationOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getSameDayCancellationOverview, {
    enabled,
    queued,
  })
}
